import Tr from 'translations/Translations';


export const PurchasingGroupDocumentStatus = {
    NEW: "NEW",
    PUBLISHED: "PUBLISHED",
    WITHDRAWN: "WITHDRAWN"
}
const _TR_PREFIX = 'purchasing_group_document_status_';

export const PurchasingGroupDocumentStatusLabel = (status) => status ? Tr(_TR_PREFIX + status.toLowerCase()) : null;